// src/stone/illustrations/StonjiChatIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiChatIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 95 60",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M94.669 47.68a4.944 4.944 0 0 1-4.573 5.286l-26.337 1.91-62.203 4.51C.234 59.48-.509 57.903.404 56.943l9.935-10.407L7.736 10.66a4.94 4.94 0 0 1 4.573-5.285L86.256.013a4.94 4.94 0 0 1 5.285 4.573l2.943 40.555z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M24.036 43.343a.374.374 0 0 1-.027-.747l33.842-2.598a.37.37 0 0 1 .403.345.374.374 0 0 1-.345.403l-33.845 2.597zM23.351 31.013a.374.374 0 0 1-.027-.748l48.86-3.752a.37.37 0 0 1 .402.345.374.374 0 0 1-.345.402l-48.86 3.75zM22.204 19.678a.374.374 0 0 1-.028-.747l34.588-2.655a.37.37 0 0 1 .402.345.374.374 0 0 1-.345.402l-34.59 2.653q-.014.002-.027.002M61.419 16.665a.374.374 0 0 1-.028-.747l18.283-1.405a.37.37 0 0 1 .402.345.374.374 0 0 1-.345.402L61.45 16.665z"
        }
      )
    ]
  }
);
var StonjiChatIllustration_default = StonjiChatIllustration;

export {
  StonjiChatIllustration_default
};
